/**
 * PATH: packages/email-hub/src/feature/components/email-preview-pane/PreviewOverlays.tsx
 * FILE_ID: EMAILHUB-EMAILPREVIEWPANE-OVERLAYS-001
 * PURPOSE: Render preview-owned modals, drawers, menus, and peek panels.
 */
import { CardPeekDrawer } from '@quotech/kanban-host'
import { AllocateBoardDialog } from '../AllocateBoardDialog'
import LinkToJobModal from '../LinkToJobModal'
import { InlineImageLightbox } from '../InlineImageLightbox'
import { InlineImageMenu } from '../InlineImageMenu'
import { JobPeekPanel } from '../JobPeekPanel'
import { BoardPeekPanel } from '../BoardPeekPanel'
import { BillDocDrawer } from '../BillDocDrawer'
import { RequestRuleDialog } from '../RequestRuleDialog'
import type { PreviewOverlaysProps } from './types'

export function PreviewOverlays({
  email,
  onRefetch,
  onOpenInMarkup,
  showLinkModal,
  setShowLinkModal,
  imageInteractions,
  peekCard,
  setPeekCard,
  peekJob,
  setPeekJob,
  navigateToJob,
  peekBoardOpen,
  setPeekBoardOpen,
  navigateToBoard,
  billDocOpen,
  setBillDocOpen,
  ruleDialogOpen,
  setRuleDialogOpen,
  canRequestRule,
  kanbanApi,
  kanbanOrgId,
  allocateOpen,
  setAllocateOpen,
}: PreviewOverlaysProps) {
  return (
    <>
      {showLinkModal && (
        <LinkToJobModal
          emailId={email.id}
          emailSubject={email.subject || '(no subject)'}
          emailBody={email.body_text || email.body_preview || ''}
          emailFrom={email.from_address || ''}
          isOpen
          onClose={() => setShowLinkModal(false)}
        />
      )}
      <InlineImageLightbox
        image={imageInteractions.lightboxImage}
        emailId={email.id}
        onClose={imageInteractions.closeLightbox}
        onOpenInMarkup={onOpenInMarkup}
      />
      <InlineImageMenu
        state={imageInteractions.menu}
        onClose={imageInteractions.closeMenu}
        onOpenLightbox={imageInteractions.openLightbox}
        onOpenInMarkup={onOpenInMarkup}
      />
      {peekCard && (
        <CardPeekDrawer
          cardId={peekCard.cardId}
          boardId={peekCard.boardId}
          onClose={() => setPeekCard(null)}
        />
      )}
      {peekJob != null && (
        <JobPeekPanel
          jobId={peekJob}
          jobName={email.job_id === peekJob ? email.job_name : null}
          onClose={() => setPeekJob(null)}
          onOpen={navigateToJob}
        />
      )}
      {peekBoardOpen && email.allocation_summary && (
        <BoardPeekPanel
          summary={email.allocation_summary}
          api={kanbanApi}
          onClose={() => setPeekBoardOpen(false)}
          onOpen={navigateToBoard}
        />
      )}
      {billDocOpen && (
        <BillDocDrawer
          email={email}
          onClose={() => setBillDocOpen(false)}
        />
      )}
      {allocateOpen && (
        <AllocateBoardDialog
          emailId={email.id}
          alreadyAllocated={Boolean(email.allocation_summary)}
          api={kanbanApi}
          orgId={kanbanOrgId}
          onClose={() => setAllocateOpen(false)}
          onAllocated={() => onRefetch?.()}
        />
      )}
      {ruleDialogOpen &&
        canRequestRule &&
        kanbanOrgId != null && (
          <RequestRuleDialog
            api={kanbanApi}
            orgId={kanbanOrgId}
            emailId={email.id}
            senderAddress={email.from_address}
            category={email.category}
            onClose={() => setRuleDialogOpen(false)}
            onApplied={onRefetch}
          />
        )}
    </>
  )
}
